export default {
    methods: {
        initCss() {
            setTimeout(function () {
                $('.map_loader').addClass('close');
            }, 2000);

            setTimeout(function () {
                $('.fadeIn').fadeIn('slow');
                $('.fadeIn').css('opacity', '1');
                $('.left').css('transform', 'translateX(0)');
                $('.right').css('transform', 'translateX(0)');
            }, 2500);
            var $show_control = $('.show_control');
            var control_box = $('.control_box');
            $show_control.bind('click', function () {
                control_box.slideToggle();
                $(this).toggleClass('active');
            });
            $(window).resize(function () {
                var w_width = $(window).width();
                if (w_width >= 768) {
                    control_box.removeAttr('style');
                }
            });
        },
    }
}